import { Button } from "@mui/joy";
import { Dialog, DialogActions } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import {
  setTimerFormOpen,
  stagedTimerSelector,
  timerFormOpenSelector,
  updateStagedTimer,
} from "../redux";
import {
  useDeleteKronosTimerMutation,
  useUpdateKronosTimerMutation,
} from "../../redux/kronos/kronosEndpoints";
import { KronosTimerForm } from "./kronosTimerForm";

/**
 *
 * @returns {ReactElement} KronosTimerPopper page
 */
export function KronosTimerDialog() {
  const open = useSelector(timerFormOpenSelector);
  const stagedTimer = useSelector(stagedTimerSelector);
  const dispatch = useDispatch();
  const [updateTimer] = useUpdateKronosTimerMutation();
  const [deleteTimer] = useDeleteKronosTimerMutation();

  const close = () => {
    dispatch(setTimerFormOpen(false));
  };

  const save = async () => {
    if (stagedTimer && stagedTimer.id) {
      await updateTimer({ id: stagedTimer.id, body: stagedTimer });
      close();
    }
  };

  const onDelete = async () => {
    if (stagedTimer) await deleteTimer(stagedTimer.id);
    close();
  };

  return (
    <Dialog open={open} onClose={close}>
      <KronosTimerForm
        timer={stagedTimer}
        onChange={(e) => dispatch(updateStagedTimer(e))}
      />
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        {stagedTimer?.id ? (
          <Button size="sm" color="danger" variant="soft" onClick={onDelete}>
            Delete
          </Button>
        ) : (
          []
        )}
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button size="sm" onClick={close} color="neutral" variant="soft">
            Close
          </Button>
          <Button size="sm" onClick={save}>
            Save & Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
